import { type ReactNode } from "react";

interface TypographyCardProps {
  label: string;
  children: ReactNode;
  description: string;
}

export function TypographyCard({ label, children, description }: TypographyCardProps) {
  return (
    <div className="border border-[#293129]/20 p-8 md:p-12">
      <p className="text-[10px] tracking-widest uppercase font-bold opacity-50 mb-6 border-b border-[#293129]/10 pb-4">
        {label}
      </p>
      {children}
      <p className="mt-8 text-[10px] tracking-[0.2em] uppercase leading-loose opacity-70">
        {description}
      </p>
    </div>
  );
}
